export default __webpack_public_path__ + "static/media/pvilla5-4.8138a3ac.jpg";